import React from 'react';

// DSP-13954 Navigation / Notification
const Notifications = () => (
	<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M6.50002 8.5C6.50002 5.46243 8.96245 3 12 3C15.0376 3 17.5 5.46243 17.5 8.5V13.0229L19.7263 16.3623C20.3354 17.276 19.6804 18.5 18.5822 18.5H15.1631C14.8245 19.9333 13.5368 21 12 21C10.4632 21 9.17556 19.9333 8.83698 18.5H5.41784C4.31963 18.5 3.66459 17.276 4.27377 16.3623L6.50002 13.0229V8.5ZM10.4184 18.5C10.6993 19.0912 11.3019 19.5 12 19.5C12.6981 19.5 13.3007 19.0912 13.5816 18.5H10.4184ZM12 4.5C9.79088 4.5 8.00002 6.29086 8.00002 8.5V13.1069C8.00002 13.3483 7.92857 13.5842 7.79469 13.7851L5.6514 17H18.3486L16.2053 13.7851C16.0715 13.5842 16 13.3483 16 13.1069V8.5C16 6.29086 14.2092 4.5 12 4.5Z"
			fill="#44546F"
		/>
	</svg>
);

export default Notifications;
